import { ICONS } from '@ohif/ui';
import React, { SyntheticEvent, useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../store/store';
import { Loader , useTheme } from '@ohif/ui';
import { useDispatch, useSelector } from 'react-redux';
import patientStudies from '@custom/rtk-apis/patients/patientStudies';
import { closeStudiesModal } from '@custom/store/slices/Patients/patientStudiesSlice';
import getReportId from '@custom/rtk-apis/report/GetReportId';
import { servicesManager } from '../../../app/src/App';

const Studies = ({ activeTabIndex }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>()
    const getReportIdData = useSelector((state: RootState) => { return state?.getReportIdResponse });
    const { uhid } = useParams<{ uhid: string }>();
    const { isDarkMode } = useTheme();
    const { uiNotificationService } = servicesManager.services;

    const viewStudyHandler = (item, type) => {
        const value = item?.["0020000D"]?.Value?.[0];
        const modality = item?.['00080061']?.Value?.[0];
        if (type === 'study') {
            navigate(`/viewer?StudyInstanceUIDs=${encodeURIComponent(value)}&modalityType=${modality}`);
        }
        else if (type === 'report') {
            let obj = {
                studyInstanceUID: value
            }
            dispatch(getReportId(obj))
        }
    }

    useEffect(() => {
        if (getReportIdData?.status === "ERROR" && getReportIdData?.msg === "No report found for this study.") {
            const result = getReportIdData?.result || {};
            if (Object.keys(result).length === 0) {
                uiNotificationService.show({
                    title: "Warning",
                    message: "Report not found.",
                    position: "topRight",
                    type: "error",
                });
            }
        }
    }, [getReportIdData]);

    const formatTime = (timeString) => {
        if (!timeString) return '';

        const hours = parseInt(timeString.substring(0, 2), 10);
        const minutes = timeString.substring(2, 4);
        const period = hours >= 12 ? 'PM' : 'AM';

        const formattedHours = hours % 12 || 12; // Convert to 12-hour format
        return `${formattedHours}:${minutes} ${period}`;
    };

    const { msg, status, result, loading } = useSelector((state: RootState) => {
        return state?.patientStudiesResponse;
    });

    useEffect(() => {
        if (activeTabIndex === 4) {
            callPatientStudies()
        }
    }, [activeTabIndex])

    useEffect(() => {
        if (getReportIdData?.status === "SUCCESS") {
            navigate(`/report/preview/${getReportIdData?.result?._id}`)
        }
    }, [getReportIdData])

    const callPatientStudies = () => {
        dispatch(patientStudies({ uhid: uhid }))
    }

    useEffect(() => {
        if (status === 'SUCCESS') {
            dispatch(closeStudiesModal())
        }
    }, [status])

    return (
        <div className='mt-1'>
            {result?.length > 0 ? (
                result.map((item, index) => {
                    const getValueSafely = (tag) => {
                        try {
                            const value = item?.[tag]?.Value?.[0];
                            if (tag === '00080020' && value) {
                                // Assume value is in YYYYMMDD format, e.g., "20240908"
                                const year = value.substring(0, 4);
                                const month = value.substring(4, 6);
                                const day = value.substring(6, 8);
                                return `${day}-${month}-${year}`;
                            }
                            if (tag === '00080030' && value) {
                                return formatTime(value);
                            }
                            if (tag === '00080020' && !value) {
                                return '--';
                            }
                            if (tag === '00080030' && !value) {
                                return '--';
                            }
                            if (tag === '00081030' && !value) {
                                return '--';
                            }
                            if (tag === '00080061' && !value) {
                                return '--';
                            }
                            if (tag === '00080050' && !value) {
                                return '--';
                            }
                            if (tag === '00200010' && !value) {
                                return '--';
                            }
                            return value ?? '';
                        } catch (error) {
                            return '';
                        }
                    };

                    return (
                        <div key={index} className='rounded-lg studiesAccordion mb-4' style={{ backgroundColor: isDarkMode ? '#ffffff6e' : '#ffffff6e' }}>
                            <div className='internalflex'>
                                <div className='studies-heading'>
                                    Study Date: <span>{getValueSafely('00080020')}</span>
                                </div>
                                <div className='studies-heading'>
                                    Study Time: <span>{getValueSafely('00080030')}</span>
                                </div>
                                <div className='studies-heading'>
                                    Description: <span>{getValueSafely('00081030')}</span>
                                </div>
                                <div className='studies-heading'>
                                    Modality: <span>{getValueSafely('00080061')}</span>
                                </div>
                                <div className='studies-heading'>
                                    Accession: <span>{getValueSafely('00080050')}</span>
                                </div>
                                <div className='studies-heading'>
                                    Instance: <span>{getValueSafely('00200010')}</span>
                                </div>
                            </div>
                            <div className='internalflex'>
                                <button>
                                    <span><img src={ICONS.preview} alt="View Report" title="View Report" onClick={() => viewStudyHandler(item, 'report')} /></span>
                                </button>
                                <button>
                                    <span><img src={ICONS.downarrow} alt="down arrow" onClick={() => viewStudyHandler(item, 'study')} /></span>
                                </button>
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className={`${isDarkMode ? "text-white" : "text-black"}`}>
                    <p>No studies found.</p>
                </div>
            )}
            <Loader isLoaderOpen={loading || getReportIdData?.loading} />
        </div>
    )
}

export default Studies
